import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCwz19-Dg2M0KdGOcnst1_rlj5vgXG01MA",
  authDomain: "fintech-3bad6.firebaseapp.com",
  projectId: "fintech-3bad6",
  storageBucket: "fintech-3bad6.firebasestorage.app",
  messagingSenderId: "278253635489",
  appId: "1:278253635489:web:d9c33956d261c6d49eade0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;